import { useRef, useState } from "react";
import { SketchPicker } from "react-color";
import { useOnBlur } from "../useBlur";

export interface ColorPickerProps {
    color: string;
    onChange: (color: string) => void;
}

export const LabelColorPicker = (props: ColorPickerProps) => {
    const [open, setOpen] = useState(false);

    const pickerRef = useRef<HTMLDivElement|null>(null);

    const onBgColorUpdate = (color: string) => {
        props.onChange(color);
    }

    useOnBlur(pickerRef, ()=>setOpen(false));

    return <div ref={pickerRef}>
        <div className="h-6 w-6 cursor-pointer" 
            style={{background: props.color}}
            onClick={()=>setOpen(true)}
        />
        <div className={`absolute left-0 ${!open?'hidden':''}`} style={{zIndex: 5}}>
            <SketchPicker
                color={props.color}
                onChangeComplete={c=>onBgColorUpdate(`rgba(${c.rgb.r}, ${c.rgb.g}, ${c.rgb.b}, ${c.rgb.a||1})`)}
            />
        </div>
    </div>
};
